import { useEffect } from 'react';

export const useTouchInteraction = (isOpen) => {
  useEffect(() => {
    if (isOpen) {
      // Prevent scrolling on the body when mobile menu is open
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      
      // Improve touch interactions on mobile
      const handleTouchMove = (e) => {
        // Only prevent scrolling if the touch is on the overlay
        const target = e.target;
        if (target.closest('[data-drawer-overlay]')) {
          e.preventDefault();
        }
      };

      document.addEventListener('touchmove', handleTouchMove, { passive: false });

      return () => {
        // Restore scrolling
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        document.removeEventListener('touchmove', handleTouchMove);
      };
    }
  }, [isOpen]);
};
